import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { startedAt: String }

  connect() {
    this._tick()
    this._interval = setInterval(() => this._tick(), 1000)
  }

  disconnect() {
    if (this._interval) {
      clearInterval(this._interval)
      this._interval = null
    }
  }

  _tick() {
    if (!this.hasDisplayTarget) return

    const startedAt = this.startedAtValue
    if (!startedAt) {
      this.displayTarget.textContent = "0:00"
      return
    }

    const start = new Date(startedAt).getTime()
    const now = Date.now()
    const elapsed = Math.max(0, Math.floor((now - start) / 1000))

    const minutes = Math.floor(elapsed / 60)
    const seconds = elapsed % 60
    this.displayTarget.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`
  }
}
